import RequestAbstract from "../abstract";

/**
 * A payout's receipts: the bank's proof its money was sent. Read-only for every
 * role — core attaches them, from a reply to the tg gateway bot or the cabinet's
 * manual confirm, and nothing edits or deletes one after.
 */
export default class PayoutDocuments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payout-documents";
    }

    /** The receipts of one payout, newest first. */
    async byPayout(payoutInstanceId) {
        return await this.getAllFiltered(
            [[{ field: 'payoutInstance.id', op: '=', value: payoutInstanceId }]],
            [{ field: 'id', direction: 'DESC' }]
        );
    }

    /**
     * A download token for one receipt, for files.openByTokenInNewTab. Not
     * /api/files/token/{uuid}: gateway users are denied that, while this route is
     * scoped to their own gateway's payouts.
     */
    async token(id) {
        return await this.get(`${this.link}/${id}/token`);
    }
}
